import {
  EpicPassValidateDateDocument,
  EpicPassValidateDateQueryResult,
  EpicPassValidateDateQueryVariables,
} from "@graphql/api";

export default async function epicPassValidateDate({
  id,
  pickupDate,
}: {
  id: string;
  pickupDate: string;
}): Promise<boolean> {
  const client = global.window.apolloClient;

  // Validate profile
  const vars: EpicPassValidateDateQueryVariables = { passId: id, pickupDate };
  const result: EpicPassValidateDateQueryResult = await client.query({
    query: EpicPassValidateDateDocument,
    variables: vars,
  });

  return !!result?.data?.epicPassValidateDate.valid;
}
